module.exports = __webpack_public_path__ + "static/hiq-13f95beb0c6a4b9ddc23021824658432.svg";